module.exports = __webpack_public_path__ + "static/media/jorge.3f376c5f.jpg";